// extracted by mini-css-extract-plugin
export default {"Overlay":"Modal_Overlay__5pnuy","Modal":"Modal_Modal__iNb9w"};